<div  [ngClass]="{'bg-color': bgClass}" class="header position-absolute w-100 d-flex align-items-center justify-content-between px-3 py-2">
    <button class="border-0 p-0" (click)="toggleMenu(true)"><img [ngClass]="{'image-bg' : headerImgClasses}" src="../../../assets/menu.svg" alt="Navigation menu icon"></button>
    <a href="https://sonomaplazahistory.com" target="_blank">
        <img class="logo-img" src="../../../assets/logo.png" alt="logo" [ngClass]="{'image-bg' : headerImgClasses}">
    </a>
</div>

<nav @menu *ngIf="displayMenu" class="d-flex pb-4">
  <button (click)="toggleMenu(false)" class="py-3 px-4 mr-2 position-absolute">&#x2715;</button>
  <ul class="my-auto pb-5">
    <li>
      <a [routerLink]="" fragment="iOSInstructions" (click)="toggleMenu(false)">
        <span>{{ 'sideNavBar.troubleshooting' | translate }}</span>
      </a>
    </li>
    <li class="mt-2">
      <a href="http://www.sonomaplazahistory.com/donate/">
        <span>{{ 'sideNavBar.donate' | translate }}</span>
      </a>
    </li>
    <li class="mt-5 pt-2">
      <a href="http://www.sonomaplazahistory.com/">
        <b>
          <span>{{ 'sideNavBar.exitTour' | translate }}</span>
        </b>
      </a>
    </li>
  </ul>
</nav>